module.exports = __webpack_public_path__ + "img/BZ2.b05e0d87.svg";